const FilePdf = ({
    height = 100,
    width = 100,
}: {
    height?: number
    width?: number
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 287.82 384"
            width={width}
            height={height}
        >
            <path
                fill="#e62335"
                d="M652.52 792.45h192s50.06.1 49-59.26 0-210.58 0-210.58H785.16l-1-114.16H652.52s-45.94 1.52-46.52 53 0 284.71 0 284.71 4.19 44.97 46.52 46.29z"
                transform="translate(-605.74 -408.45)"
            ></path>
            <path
                fill="#ee656c"
                d="M178.39 0L287.82 114.16 179.42 114.16 178.39 0z"
            ></path>
            <path
                fill="#fff"
                d="M661.75 618.5h13.85V692h-13.85zm6.32 31.64h23.51A8.3 8.3 0 00696 649a7.86 7.86 0 003-3.21 10.35 10.35 0 001-4.79 10.79 10.79 0 00-1-4.83 7.66 7.66 0 00-3-3.17 8.41 8.41 0 00-4.42-1.14h-23.51V618.5h23.15a25.23 25.23 0 0112.11 2.8 19.93 19.93 0 018.11 7.91 25.68 25.68 0 010 23.63 19.84 19.84 0 01-8.11 7.87 25.46 25.46 0 01-12.11 2.78h-23.15zM725.19 618.5H739V692h-13.81zm7 60.15h17.64q6.83 0 10.57-3.29t3.74-9.3v-21.63q0-6-3.74-9.3t-10.57-3.29h-17.66V618.5h17.34a36.29 36.29 0 0115.69 3.08 21.75 21.75 0 019.88 9 28.19 28.19 0 013.39 14.25v20.83a28.16 28.16 0 01-3.26 13.85 22.22 22.22 0 01-9.78 9.2q-6.52 3.28-16 3.29h-17.26zM792.12 618.5H806V692h-13.88zm5 0h43.28v13.34h-43.23zm0 31h37.66v13.35h-37.61z"
                transform="translate(-605.74 -408.45)"
            ></path>
        </svg>
    )
}

export default FilePdf
